import React from "react";
import { AdminNavigation, AProjects, Messages } from ".";
import { Route } from "react-router-dom";

export default class Admin extends React.Component {
    render() {
        return (
            <div>
                <AdminNavigation history={this.props.history} />
                <Route path={`${this.props.match.path}/projects`} component={AProjects} />
                <Route path={`${this.props.match.path}/messages`} component={Messages} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/admin.jsx